import React from "react";

import { PrismicColor } from "utils";

import {
  Box,
  Button,
  Card,
  Column,
  Columns,
  Heading,
  HStack,
  Link,
  RichText,
  Text,
  VStack,
  Wrapper,
} from "components";

function Item({ button_label, button_link, date, details, title }) {
  return (
    <Card>
      <HStack space="layout.2">
        {/* Line to the left of content */}
        <Box width={4} height="100%" bg="brand.secondary" />

        {/* Text content */}
        <VStack space="layout.1">
          <Text children={title.text} as="h2" size={700} />
          <Text children={date} size={700} color="brand.secondary" />
          <RichText html={details.html} size={500} />
          {button_link?.url && (
            <Link href={button_link.url}>
              <Button
                children={button_label}
                intent="default"
                appearance="primary"
                round={true}
              />
            </Link>
          )}
        </VStack>
      </HStack>
    </Card>
  );
}

export function Calendar({ title, no_events_message, items, background }) {
  return (
    <Wrapper
      id={title && title.text}
      py={{ _: "layout.5", md: "layout.6" }}
      bg={PrismicColor(background)}
    >
      <VStack space={{ _: "layout.4", md: "layout.6" }}>
        {/* Title and No Events Message */}
        {title && title.text && <Heading children={title.text} size={700} />}

        {no_events_message && no_events_message.html && !items && (
          <RichText html={no_events_message.html} color="label.0" size={500} />
        )}
        {/* Event Items */}
        {items && items[0] && items[0].title && items[0].title.text && (
          <Columns as="ul" spaceX="layout.5" spaceY="layout.4">
            {items.map((item, i) => (
              <Column width={{ _: 1 / 1, lg: 4 / 12 }} key={`eventItem-${i}`}>
                <Item {...item} />
              </Column>
            ))}
          </Columns>
        )}
      </VStack>
    </Wrapper>
  );
}
